import React, { useEffect, Suspense, lazy } from 'react';
import { useDispatch } from 'react-redux';
import { claimActions, httpRequestsOnErrorsActions } from 'store';
import { FindErrorItem, Images, useModal } from 'utils';
import { CustomDelete } from '../customDelete';

// Dynamic import: `components` is a lower layer than `pages`. Statically importing a
// pages-layer component from here closes a circular dependency that crashes on module init.
// Loading it lazily defers resolution to render time, after the module graph is initialized.
// Targets the standalone `openClaimDetails` module (not a barrel) to keep the async chunk small.
const OpenClaimDetails = lazy(() => import('pages/billing/claim/openClaimDetails').then((m) => ({ default: m.OpenClaimDetails })));

const ACTION_TYPE = 'MARK_AS_SECONDARY_BILLING';
export const MarkSecondaryBilling = ({ claim, mark, afterSuccess }) => {
    const dispatch = useDispatch();
    const { open, close } = useModal();
    const backError = FindErrorItem(ACTION_TYPE);
    const title = mark ? 'Mark Claim for Secondary Billing' : 'Unmark Secondary Billing';
    const desc = mark
        ? 'Are you sure you want to delete this role? This action is not reversible.'
        : 'Are you sure you want to unmark this claim?';
    const innerText = mark ? 'Mark Claim' : 'Unmark Claim';

    useEffect(() => {
        if (backError && backError?.error?.message === 'Cannot mark claim for secondary billing as it has an associated invoice.') {
            open(
                <CustomDelete
                    info={'Cannot Mark Claim as Secondary'}
                    innerText={innerText}
                    okBtn={true}
                    body={
                        <div>
                            <p className="modal-header-sub" style={{ marginTop: '-18px' }}>
                                    <OpenClaimDetails claimId={claim?.id} displayId={claim?.displayId} />
                                {/*<a*/}
                                {/*    href={`/billedClaim/${claim?.id}`}*/}
                                {/*    target={'_blank'}*/}
                                {/*    rel="noopener noreferrer"*/}
                                {/*    style={{ color: '#D92D20', marginRight: 4 }}>*/}
                                {/*    {claim?.displayId}*/}
                                {/*</a>*/}
                                can’t be marked for secondary billing. An invoice has already been generated for this claim.
                            </p>
                            <div className="deleting-client-info-box" style={{ alignItems: 'flex-start', margin: '12px 0 0 0' }}>
                                <img style={{ marginTop: '3px' }} src={Images.receipt} alt="icon" />
                                <p style={{ fontWeight: 400 }}>Invoice:</p>
                                <p style={{ fontWeight: 400, color: '#0C66E4' }}>{backError?.error?.data}</p>
                            </div>
                        </div>
                    }
                />
            );
        }
        dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }, [backError]);

    return (
        <CustomDelete
            text={desc}
            info={title}
            innerText={innerText}
            color={'blue'}
            handleDel={() => dispatch(claimActions.markAsSecondaryBilling(claim?.id, { mark: mark }))}
            afterSuccess={() => {
                close();
                afterSuccess();
            }}
            actionType={ACTION_TYPE}
            body={
                <div>
                    <div className="deleting-client-info-box" style={{ alignItems: 'flex-start', marginBottom: 12 }}>
                        <img style={{ marginTop: '3px' }} src={Images.receipt} alt="icon" />
                        <p style={{ fontWeight: 400, color: '#0C66E4' }}>{claim?.displayId}</p>
                    </div>
                    {mark && (
                        <p className="delete-modal-note" style={{ marginBottom: 32 }}>
                            <span>Note:</span>
                            This will add the claim to the Secondary Claims queue and show a secondary flag in Submitted Claims.
                        </p>
                    )}
                </div>
            }
        />
    );
};
